import Swal from "sweetalert2";
export default Swal.mixin({
  target: ".ember-application"
});